import React, { useEffect, useState } from "react";
// assets
import { IitemLayout } from "types/home/TypeLayout";
import Menubar from "./MenuBar";
import { useLocation, useNavigate } from "react-router-dom";
import AppUpdateModal from "utils/mapModals/AppUpdateModal";
import { useCheckVersionMutation } from "redux/RTQ/IlenkradApi";
import { appVersion } from "services/config/url";
import { HomeLayoutProps } from "types/v2/Home/HomeLayoutProps";
import { calculatePageSize } from "utils/v2/pageSize";
import SupportIcon from "assets/icons/v2/SupportIcon/SupportIcon";

const HomeLayout: React.FC<HomeLayoutProps> = ({
  children,
  isTrackerStatusModalOpen,
  setIsTrackerStatusModalOpen,
  setShowMenuBar,
  showMenuBar,
}) => {
  const navigate = useNavigate();
  const hideNav = localStorage.getItem("hideNav");
  const [showOverLay, setshowOverLay] = useState<boolean>(false);
  const [updateModal, setUpdateModal] = useState<boolean>(false);
  const [forceUpdate, setForceUpdate] = useState<boolean>(false);
  const [BottomItem, setBottomItem] = useState<IitemLayout[]>([
    {
      title: "خانه",
      key: 1,
      url: "icon-home",
      urlActive: "icon-homeActive",
      active: true,
      page: "/home",
    },
    {
      title: "ردیاب ها",
      key: 2,
      url: "icon-tracker",
      urlActive: "icon-trackerActive",
      active: false,
      page: "/trackers",
    },
    {
      title: "پیام ها",
      key: 3,
      url: "icon-bubbles-nav",
      urlActive: "icon-bubblesActive",
      active: false,
      page: "/notification",
    },
    {
      title: "پشتیبانی",
      key: 4,
      url: "SupportIcon",
      urlActive: "icon-servicesActive",
      active: false,
      page: "/contact-us",
    },
  ]);
  const getContentLayoutClassName = () => {
    // Check for the first condition - no bottom bar
    if (
      showBottomTabs.find((url) => url === location?.pathname) ||
      !isBottomMenuVisible ||
      location.pathname.includes("/notification/chat")
    ) {
      return "contentLayoutNonBottomBar";
    }

    // Paths that should have darker content layout
    const darkerLayoutPaths = [
      "/contact-us",
      "/online-commands",
      "/plans",
      "/transactions",
    ];

    // Check for exact path matches
    if (darkerLayoutPaths.includes(location.pathname)) {
      return "contentLayoutDarker";
    }

    // Check for path inclusions
    const darkerLayoutIncludes = [
      "/factor/",
      "/online-commands/",
      "/other-alerts/",
      "/other-settings/",
    ];
    if (darkerLayoutIncludes.some((path) => location.pathname.includes(path))) {
      return "contentLayoutDarker";
    }

    // Default case
    return "contentLayout";
  };
  const [isBottomMenuVisible, setIsBottomMenuVisible] = useState<boolean>(true);
  let hideBottomMenuWithDelay: ReturnType<typeof setTimeout>;
  useEffect(() => {
    const { height } = calculatePageSize();
    const isSmallHeight = height <= 650;
    if (isTrackerStatusModalOpen && isSmallHeight) {
      hideBottomMenuWithDelay = setTimeout(() => {
        setIsBottomMenuVisible(false);
      }, 3000);
    } else setIsBottomMenuVisible(true);
    return () => clearTimeout(hideBottomMenuWithDelay);
  }, [isTrackerStatusModalOpen]);
  const changePage = (index: number, page: string) => {
    setIsTrackerStatusModalOpen(false);
    navigate(`${page}`);
    const newState = [...BottomItem];
    newState.forEach((p) => (p.active = false));
    const findPage = newState.findIndex((page) => page.key === index + 1);
    const changeUrlActive = newState[findPage];
    changeUrlActive.active = true;
    newState[findPage] = changeUrlActive;
    setBottomItem(newState);
  };
  const openMenuBar = () => {
    setShowMenuBar(!showMenuBar);
    setshowOverLay(true);
    if (!showMenuBar) {
      setIsTrackerStatusModalOpen(false);
    }
  };

  const [
    mutateCheckVersion,
    { data: dataCheckVersion, isSuccess: isSuccessCheckVersion },
  ] = useCheckVersionMutation();

  useEffect(() => {
    mutateCheckVersion({ current_version: appVersion });
  }, []);

  useEffect(() => {
    const VersionData: any = dataCheckVersion;
    if (isSuccessCheckVersion) {
      setUpdateModal(VersionData?.needs_update);
      setForceUpdate(VersionData?.needs_force_update);
    }
  }, [isSuccessCheckVersion]);

  const navigateToProfile = () => {
    setIsTrackerStatusModalOpen(false);
    navigate("/profile");
  };
  const closeUpdateModal = () => {
    setUpdateModal(false);
  };

  const showBottomTabs = [
    "/notification/chat",
    "/add-tracker",
    "/location-history",
    "/reviews",
    "/notification/filter",
    "/login-touch",
    "/navigation-popup",
  ];
  const transparentMenubar = [
    "/notification/filter",
    "/reviews",
    "/contact-us",
  ];

  const dontShowMenuBar = ["/login-touch"];
  const location = useLocation();

  return (
    <>
      <div
        className={
          isBottomMenuVisible ? "layoutContainer" : "layoutContainerHidden"
        }
      >
        <Menubar
          showOverLay={showOverLay}
          open={showMenuBar}
          onClose={openMenuBar}
        />
        <AppUpdateModal
          onClose={closeUpdateModal}
          isOpen={updateModal}
          force={forceUpdate}
        />
        <div
          className={
            dontShowMenuBar.find((url: string) => url === location?.pathname)
              ? "headBarContainerHidden"
              : transparentMenubar.find(
                  (url: string) => url === location?.pathname,
                )
              ? "headerBarContainerTransparent"
              : "headerBarContainer"
          }
        >
          <div onClick={openMenuBar} className="containerIconheaderBar ">
            <div className="icon-menu" />
          </div>
          <div className="containerIconheaderBar2">
            <div className="flexRowHeaderbar">
              <div onClick={navigateToProfile}>
                <div className="icon-user" />
              </div>
            </div>
          </div>
        </div>
        <div className={getContentLayoutClassName()}>{children}</div>

        {hideNav ||
        showBottomTabs.find((url: string) => url === location?.pathname) ||
        location.pathname.includes("/notification/chat") ? null : (
          <div
            className={
              isBottomMenuVisible
                ? "bottomBarContainer"
                : "bottomBarContainer bottomBarContainerHidden"
            }
          >
            {BottomItem.map((item, index) => (
              <div onClick={() => changePage(index, item.page)} key={item.key}>
                {item.key === 4 ? (
                  !window.location.pathname.includes(item.page) ? (
                    <SupportIcon />
                  ) : (
                    <SupportIcon active />
                  )
                ) : (
                  <div
                    className={
                      !window.location.pathname.includes(item.page)
                        ? item.url
                        : item.urlActive
                    }
                  />
                )}
                <div
                  className={
                    !window.location.pathname.includes(item.page)
                      ? "titleBottomBar"
                      : "titleBottomBarActive"
                  }
                >
                  {item.title}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};
export default HomeLayout;
